module.exports = __webpack_public_path__ + "img/x-icon-red.e3524f71.svg";